import { Button } from "@benefit-systems/common-components";
import { arrayOf, func, shape, string } from "prop-types";
import { useMemo, useState } from "react";

import DuplicateAlreadyOrdered from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/DuplicateAlreadyOrdered/duplicateAlreadyOrdered";
import { FORM_RECEIVERS } from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/constants";
import Modal from "web/Pages/Checkout/Subscription/Modal";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import getValuesFromFieldsStructured from "web/utils/page/product/subscription/getValuesFromFieldsStructured";

import {
  DUPLICATE_CALL,
  DuplicateStatus,
  INITIAL_DUPLICATE_RECEIVER_DATA,
} from "web/constants/benefits";
import formLabels from "web/constants/formLabels";

import classify from "web/classify";

import ActiveFormData from "../ActiveFormData/activeFormData";
import DuplicateCardForm from "../DuplicateCardForm/duplicateCardForm";
import defaultClasses from "./benefitUserData.scss";

const handleShowModal = (formData, setModal) => {
  // modal only for ACTIVE forms with receiver type employee (only interested in data attribute)
  setModal(
    <Modal
      title={
        formData?.name
          ? formData.name
          : __("Formularz świadczeń abonamentowych")
      }
      description={formData?.description}
      closeLabel={__("Zamknij")}
    >
      <ActiveFormData
        data={formData.data}
        values={getValuesFromFieldsStructured(formData.fieldsStructured)}
      />
    </Modal>
  );
};

const CheckoutSubscriptionBenefitUserData = ({
  classes,
  forms,
  activeForms,
  setModal,
  wayChooseOthersInActiveForm,
  duplicateCardData,
  setShowDuplicateButton,
  showDuplicateForm,
  handleToggleDuplicateModal,
  updatedItem,
  formDuplicateInfoMyBenefitsView,
  setFormDuplicateInfoMyBenefitsView,
}) => {
  const [duplicateReceiverData, setDuplicateReceiverData] = useState(
    INITIAL_DUPLICATE_RECEIVER_DATA
  );

  const duplicateFormFunc = (
    singleForm,
    index,
    benefitFormsWithDuplicateStatus
  ) => {
    const { receiver, receiverId } = singleForm;
    return (
      duplicateCardData &&
      benefitFormsWithDuplicateStatus && (
        <div>
          {duplicateReceiverData.showForm &&
            duplicateReceiverData.index === index &&
            duplicateReceiverData.receiver === receiver &&
            showDuplicateForm === DUPLICATE_CALL.from_desktop && (
              <DuplicateCardForm
                duplicateCardData={duplicateCardData}
                receivers={receiverId}
                setShowDuplicateButton={setShowDuplicateButton}
                showDuplicateForm={showDuplicateForm}
                handleToggleDuplicateModal={handleToggleDuplicateModal}
                updatedItem={updatedItem}
                setDuplicateReceiverData={setDuplicateReceiverData}
                setFormDuplicatInfo={setFormDuplicateInfoMyBenefitsView}
                benefitFormsWithDuplicateStatus={
                  benefitFormsWithDuplicateStatus
                }
              />
            )}
          {benefitFormsWithDuplicateStatus.duplicateOrderStatus ===
            DuplicateStatus.NEVER_ORDERED &&
            (duplicateReceiverData.index !== index ||
              duplicateReceiverData.receiver !== receiver) && (
              <div>
                <div className={defaultClasses.duplicateElement}>
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() =>
                      setDuplicateReceiverData({
                        showForm: true,
                        index,
                        receiver,
                      })
                    }
                    disabled={duplicateReceiverData.showForm}
                  >
                    {__("Zamów duplikat")}
                  </Button>
                </div>
              </div>
            )}
          {benefitFormsWithDuplicateStatus.duplicateOrderStatus ===
            DuplicateStatus.ALREADY_ORDERED && (
            <DuplicateAlreadyOrdered duplicateCardData={duplicateCardData} />
          )}
        </div>
      )
    );
  };

  const getForms = (forms, title) => (
    <>
      <strong className={classes.description}>{title}</strong>

      {forms.map((singleForm, index) => {
        const benefitFormsWithDuplicateStatus =
          isArrayHasItems(formDuplicateInfoMyBenefitsView) &&
          formDuplicateInfoMyBenefitsView.find(
            (ele) => ele.id === singleForm.id
          );

        const duplicateView = duplicateFormFunc(
          singleForm,
          index,
          benefitFormsWithDuplicateStatus
        );
        return singleForm?.data ? (
          <div
            className={`${classes.singleFormWrapper} ${
              duplicateReceiverData.showForm
                ? classes.singleFormWrapper__duplicateForm
                : ""
            }`}
          >
            <div className={classes.fieldset} key={singleForm.id}>
              <div className={classes.legend}>{`${index + 1}. ${__(
                "osoba"
              )}:`}</div>
              <dl className={classes.fieldList}>
                <button
                  className={classes.button}
                  type="button"
                  onClick={() => handleShowModal(singleForm, setModal)}
                  key={`${singleForm.id}_button`}
                >
                  {__("Zobacz podgląd")}
                </button>
              </dl>
            </div>
            {duplicateView}
          </div>
        ) : null;
      })}
    </>
  );

  const getFormsFromFields = (formList, description, indexOffset = 0) => {
    const formFields = formList.map((singleForm, index) => {
      const fieldsStructured = singleForm?.receiverEmail
        ? [{ type: "receiverEmail", value: singleForm.receiverEmail }]
        : singleForm.fieldsStructured;

      return fieldsStructured
        ? getSingleForm(
            fieldsStructured,
            singleForm.id,
            index + indexOffset,
            singleForm
          )
        : null;
    });
    return (
      <>
        <p className={classes.description}>{description}</p>
        {formFields}
      </>
    );
  };

  const getSingleForm = (fieldsStructured, id, index, singleForm) => {
    const benefitFormsWithDuplicateStatus =
      isArrayHasItems(formDuplicateInfoMyBenefitsView) &&
      formDuplicateInfoMyBenefitsView.find((ele) => ele.id === singleForm.id);

    const duplicateView = duplicateFormFunc(
      singleForm,
      index,
      benefitFormsWithDuplicateStatus
    );
    const legend = `${index + 1}. ${__("osoba")}:`;

    return fieldsStructured ? (
      <div
        className={`${classes.singleFormWrapper} ${
          duplicateReceiverData.showForm
            ? classes.singleFormWrapper__duplicateForm
            : ""
        }`}
      >
        <div className={classes.fieldset} key={id}>
          <div className={classes.legend} data-t1={legend}>
            {legend}
          </div>
          <dl className={classes.fieldList}>{getData(fieldsStructured, id)}</dl>
        </div>
        {duplicateView}
      </div>
    ) : null;
  };

  const getData = (fieldsStructured, id) => {
    return fieldsStructured.map(({ type, value, label }) => {
      const fieldValue = value || "-";

      return (
        <div className={classes.item} key={`${id}_${type}`}>
          <dt className={classes.label}>{label || __(formLabels[type])}</dt>
          <dd className={classes.value} data-t1={type} data-t2={fieldValue}>
            {fieldValue}
          </dd>
        </div>
      );
    });
  };

  const formsList = useMemo(() => {
    // if ACTIVE forms override
    if (isArrayHasItems(activeForms)) {
      // different form types are split into groups by their receiver type.
      const [employeeForms, otherForms] = activeForms.reduce(
        ([employee, other], singleForm) => {
          return singleForm?.receiver === "employee"
            ? [[...employee, singleForm], other]
            : [employee, [...other, singleForm]];
        },
        [[], []]
      );
      return (
        <>
          {isArrayHasItems(employeeForms)
            ? getForms(
                employeeForms,
                __("Dane osób, dla których wybierasz abonament.")
              )
            : null}
          {isArrayHasItems(otherForms) &&
            (wayChooseOthersInActiveForm === FORM_RECEIVERS.EMPLOYEE
              ? getForms(otherForms, __("Dane osób dodatkowych"))
              : getFormsFromFields(
                  otherForms,
                  __(
                    "Na podany e-mail zostanie wysłany formularz świadczeń abonamentowych"
                  ),
                  employeeForms.length ? 1 : 0
                ))}
        </>
      );
    }

    // REGULAR forms OR null
    return isArrayHasItems(forms)
      ? getFormsFromFields(
          forms,
          __("Dane osoby, dla której wybierasz abonament.")
        )
      : null;
  }, [
    JSON.stringify(forms),
    JSON.stringify(activeForms),
    duplicateReceiverData,
    formDuplicateInfoMyBenefitsView,
  ]);

  return formsList ? (
    <div>
      <div className={classes.root}>{formsList}</div>
    </div>
  ) : null;
};

CheckoutSubscriptionBenefitUserData.propTypes = {
  classes: shape({}).isRequired,
  forms: arrayOf(shape({})),
  activeForms: arrayOf(shape({})),
  setModal: func,
  wayChooseOthersInActiveForm: string.isRequired,
  duplicateCardData: shape({}),
  showDuplicateForm: string,
  handleToggleDuplicateModal: func,
  updatedItem: shape({}),
};

CheckoutSubscriptionBenefitUserData.defaultProps = {
  forms: [],
  activeForms: [],
  setModal: () => {},
  duplicateCardData: null,
  showDuplicateForm: null,
  handleToggleDuplicateModal: null,
  updatedItem: {},
};

export default classify(defaultClasses)(CheckoutSubscriptionBenefitUserData);
